import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class BlockEventBehaviour extends AbstractDataAttributeBehaviour {
    attrNames = {
        container: 'data-input-restriction',
        events: 'data-input-events'
    };

    getContainerSelector = () => '[' + this.attrNames.container + ']';

    getEvents = container => container.getAttribute(this.attrNames.events).split(',');

    initContainer = (container) =>  {
        let events = this.getEvents(container);
        events.forEach( eventOption => {container.addEventListener(eventOption, function(event){
            event.preventDefault()
        })});



    };
}
